<template>
  <div>
    <div class="content">
      <div class="service_content">
        <p class="title">关于<common-data name="appShortName_26" v-common-display/></p>
        <!-- <p class="title2">股票交易工具</p> -->
        <div class="p_text" style="margin-top: 15px">
        <p  class="text_content">
          面向专业投资者，基于财务分析，提供多因子估值图表，利润滤镜、风险甄别、EVA分析等风险研究工具...
        </p>
        </div>
        <div class="p_text">
          <p class="text_content">
           基于传统的技术分析方法出的买卖点，都是右侧信号，有明显的滞后性。
          </p>
          <p class="text_content">
          <common-data name="appShortName_26" v-common-display/>提供左侧的价格研究方法！原创的多因子估值算法，基于左侧交易逻辑，对引起股票价格变化的多个因子数据项进行深度加工，为投资者提供一个寻找左侧买卖点的研究工具。判断一只股票现在处于高位还是低位，现在是合适的买点？现在是合适的卖点？为你提供重要参考。
          </p>
          <p class="text_content">
            投资是一个机遇，也是一个风险。选股固然重要，买到上涨的股票才能产生利润，但是也要控制好风险，避开有风险的股票也同样重要！软件提供基于财务分析的个股风险研究工具，能够分析企业的盈利质量，发现企业的潜在经营风险，未雨绸缪，避免踩雷买到风险股。
          </p>
          <p class="text_content">
            软件还提供原创的股息率统计算法，支持基于分红数据的一种另类投资方法。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.content {
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=17) no-repeat top;
  width: 100%;
  min-height: 480px;
  padding-top: 236px;
}
.service_content {
  width: 990px;
  margin: 0 auto;
  background: #fff;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 0 20px -5px #ccc;
  min-height: 480px;
  padding-bottom: 50px;
}
.service_content .title {
  color: #5f5f5f;
  border-bottom: 1px dashed #a8a8a8;
  line-height: 40px;
  font-size: 22px;
}
.p_text {
  padding: 6px 0;
}
.text_content {
  text-indent: 2em;
  font-size: 14px;
  line-height: 20px;
  color: #6f6f6f;
  padding: 4px 0;
  text-align: justify;
}
.title2 {
  font-size: 16px;
  color: #5d0f0b;
  border-left: 4px solid #e24a49;
  font-weight: bold;
  padding-left: 10px;
  margin: 15px 0;
}
</style>